import { render, staticRenderFns } from "./FrFormCheckbox.vue?vue&type=template&id=485bddfc&"
import script from "./FrFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./FrFormCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports